import Text from "ab-text";
import Gallery from "ab-gallery";
import Link from "ab-link";

import "./ab-double.scss";

const Double = ({ animated, left, right, className, classname }) => {
  return (
    <div className={`ab-double ${className || classname || ""}`}>
      <div>
        <Text element="h2" animated={animated}>
          {left.title}
        </Text>
        <Gallery images={left.images} imagesMobile={left.imgmob} />
        {left.link ? (
          <Link
            prefetch={false}
            href={left.link.href || left.link.url}
            text={left.link.text || left.link.title || "Enlace"}
          />
        ) : null}
      </div>

      <div>
        {right.title ? (
          <>
            <Text element="h2" animated={animated}>
              {right.title}
            </Text>
            <Gallery images={right.images} imagesMobile={right.imgmob} />
            {right.link ? (
              <Link
                prefetch={false}
                href={right.link.href || right.link.url}
                text={right.link.text || right.link.title || "Enlace"}
              />
            ) : null}
          </>
        ) : null}
      </div>
    </div>
  );
};

export default Double;
